import React, { Component, Fragment } from "react";
import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import { FEED_QUERY } from "./LinkList";
import { USER_LINKS_QUERY } from "./Account";
import { LINKS_PER_PAGE } from "../constants";
import { fromNow, handleUnauthorized } from "../utils";

const POST_MUTATION = gql`
  mutation PostMutation($description: String!, $url: String!) {
    post(description: $description, url: $url) {
      id
      created
      url
      description
      comments {
        id
      }
      ranking
      votes {
        id
      }
      postedBy {
        id
        name
      }
    }
  }
`;

class CreateLink extends Component {
  state = {
    description: "",
    url: "",
    loading: false,
    error: "",
  };

  checkUnauthorized(error) {
    handleUnauthorized(error, this.props.history)
  }

  render() {
    const { description, url, loading } = this.state;
    return (
      <div>
        <Mutation
          mutation={POST_MUTATION}
          variables={{
            description,
            url,
          }}
          onCompleted={(data) => {
            // Duplicate link recieved, redirect
            this.setState({
              loading: false,
            });
            if (fromNow(data.post.created) > 60) {
              this.props.history.push(`/link/${data.post.id}`);
            } else {
              this.props.history.push("/new/1");
            }
          }}
          update={(store, { data }) => {
            // Duplicate link recieved
            if (fromNow(data.post.created) > 60) {
              return;
            }
            const first = LINKS_PER_PAGE;
            const skip = 0;
            const orderBy = "created_DESC";
            try {
              const feedData = store.readQuery({
                query: FEED_QUERY,
                variables: { first, skip, orderBy },
              });
              feedData.feed.links.unshift(data.post);
              store.writeQuery({
                query: FEED_QUERY,
                data: feedData,
                variables: { first, skip, orderBy },
              });
            } catch (err) {
              console.log("No feed query in cache to update");
            }

            try {
              const userFeedData = store.readQuery({
                query: USER_LINKS_QUERY,
                variables: { userId: data.post.postedBy.id },
              });
              userFeedData.userFeed.links.unshift(data.post);
              store.writeQuery({
                query: USER_LINKS_QUERY,
                data: userFeedData,
                variables: { userId: data.post.postedBy.id },
              });
            } catch (err) {
              console.log("No user feed data in cache to update");
            }
          }}
          onError={(err) => {
            this.checkUnauthorized(err)
            if (err.graphQLErrors && err.graphQLErrors.length) {
              this.setState({
                error: err.graphQLErrors[0],
                loading: false,
              });
            } else {
              this.setState({
                error: "An error occured when posting the link",
                loading: false,
              });
            }
          }}
        >
          {(postMutation) => (
            <Fragment>
              <div className="flex flex-column mt3">
                <input
                  className="mb2"
                  value={description}
                  disabled={loading}
                  onChange={(e) =>
                    this.setState({
                      description: e.target.value,
                      error:
                        e.target.value.length > 100
                          ? `Description ${e.target.value.length - 100
                          } characters too long`
                          : "",
                    })
                  }
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && e.target.value <= 100) {
                      this.setState({
                        loading: true,
                      });
                      postMutation();
                    }
                  }}
                  type="text"
                  placeholder="A description for the link"
                />
                <input
                  className="mb2"
                  value={url}
                  disabled={loading}
                  onChange={(e) =>
                    this.setState({ url: e.target.value, error: "" })
                  }
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && e.target.value <= 100) {
                      this.setState({
                        loading: true,
                      });
                      postMutation();
                    }
                  }}
                  type="text"
                  placeholder="The URL for the link"
                />
                <div className="pb2">
                  {!!this.state.error.length && this.state.error}
                </div>
              </div>
              <button
                disabled={loading}
                onClick={() => {
                  this.setState({
                    loading: true,
                  });
                  postMutation();
                }}
              >
                {loading ? "Posting" : "Submit"}
              </button>
            </Fragment>
          )}
        </Mutation>
      </div>
    );
  }
}

export default CreateLink;



// WEBPACK FOOTER //
// ./src/components/CreateLink.js